import './WhatYouGet.css';
import ListItemCard from '../../Components/Card/LIstItemCard';
import React, { useEffect, useState } from 'react'
import WhatYouGetList from '../../Data/WhatYouGet';
import SectionIds from '../../Helper/SectionId';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import AssetImage from '../../Helper/AssetImage';
import AssetImages from '../../Helper/AssetImages';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';

export default function WhatYouGet() {
    const [activeCardIndex, setActiveCardIndex] = useState(0);
    const [pauseTimer, setPauseTimer] = useState(false);

    const sectionRef = useRef(null);
    const inView = useInView(sectionRef);

    useEffect(() => {
        if (inView) {
            setActiveCardIndex(0);
            setPauseTimer(false);

        }
        else
            setPauseTimer(true)
    }, [inView])

    useEffect(() => {

        const timer = setInterval(
            () => {

                if (!pauseTimer) {

                    setActiveCardIndex(prevIndex => {

                        if (prevIndex === WhatYouGetList.length - 1) {
                            return 0;
                        }
                        else {
                            return prevIndex + 1;
                        }
                    })
                }
            }, 2000
        );
        return () => clearInterval(timer)

    }, [pauseTimer])


    return (
        <SectionWithAnalytics className='section section-wyg' id={SectionIds.sectionWhatYouGet} ref={sectionRef}>
            <h4 className='align-left'>What you Get?</h4>
            <AssetImage className="illustration" assetImage={AssetImages.illustrationWhatYouGet} />
            <ul className='container-vertical res-gap-16'>
                {
                    WhatYouGetList.map((element, index) => {
                        return <ListItemCard
                            key={index}
                            viewport={{
                                once: true,
                            }}
                            initial={
                                {
                                    opacity: 0,
                                    translateX: -50,
                                }
                            }
                            whileInView={
                                {
                                    opacity: 1,
                                    translateX: 0,

                                }
                            }
                            transition={
                                {
                                    duration: 0.1,
                                    delay: 0.1 * index,
                                    transition: 'ease'
                                }
                            }

                            icon={element.icon()}
                            title={element.title}
                            isActive={
                                activeCardIndex === index
                            }
                            onMouseEnter={() => {
                                setActiveCardIndex(index)
                                setPauseTimer(true)
                            }}
                            onMouseLeave={() => {
                                setPauseTimer(false)
                            }}
                        ></ListItemCard>

                    })
                }
            </ul>
        </SectionWithAnalytics>
    )
}
